module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "k2_upright",
    class: {
      disabled: _vm.compIsDisabled
    },
    style: ({ 
      width: _vm.px(_vm.compWidth),
      height: _vm.px(_vm.compHeight)
    })
  }, [_c('div', {
    staticClass: "k2_container",
    class: {
      prolunghe: _vm.room_size.height > _vm.heights.xl
    }
  }, [(_vm.room_size.height <= _vm.heights.xl) ? _c('img', {
    staticClass: "footup",
    attrs: {
      "src": "/images/PiedinoK2.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.room_size.height <= _vm.heights.xl) ? _c('img', {
    staticClass: "footdown",
    attrs: {
      "src": "/images/PiedinoK2.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.room_size.height <= _vm.heights.xl) ? _c('img', {
    staticClass: "footup right",
    attrs: {
      "src": "/images/PiedinoK2.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.room_size.height <= _vm.heights.xl) ? _c('img', {
    staticClass: "footdown right",
    attrs: {
      "src": "/images/PiedinoK2.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.room_size.height > _vm.heights.xl) ? _c('img', {
    staticClass: "footup",
    attrs: {
      "src": "/images/PiedinoK2-lungo.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.room_size.height > _vm.heights.xl) ? _c('img', {
    staticClass: "footdown",
    attrs: {
      "src": "/images/PiedinoK2-lungo.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.room_size.height > _vm.heights.xl) ? _c('img', {
    staticClass: "footup right",
    attrs: {
      "src": "/images/PiedinoK2-lungo.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.room_size.height > _vm.heights.xl) ? _c('img', {
    staticClass: "footdown right",
    attrs: {
      "src": "/images/PiedinoK2-lungo.svg"
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('edituprightbtn', {
    attrs: {
      "is-visible": _vm.showEdit
    },
    on: {
      "click": function($event) {
        _vm.emitOnEdit()
      }
    }
  }), _vm._v(" "), _c('checkbtn', {
    attrs: {
      "is-visible": _vm.compIsSelectable,
      "is-checked": _vm.compIsSelected
    },
    on: {
      "click": _vm.emitOnSelect
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "k2_width h8 bg-lgrey"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.compWidth) + " CM\n\t\t")])], 2), _vm._v(" "), _c('adduprightbtn', {
    attrs: {
      "is-visible": _vm.showAdd
    },
    on: {
      "click": function($event) {
        _vm.emitOnAdd()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fdab96c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/K2Upright.vue
// module id = 644
// module chunks = 0